import React from "react";

/**
 * @author Yaochao
 * @date 2021/7/21 14:00
 * @description
 */

//待发货
export const PendingSend = () => {
    return <span className="text-abnormal">待发货</span>
};

//已发货
export const Delivered = () => {
    return <span className="text-after">已发货</span>
};

//已完成
export const Completed = () => {
    return <span className="text-success">已完成</span>
};

//已完成
export const Closed = () => {
    return <span className="text-over">已关闭</span>
};

//拼团中
export const PendingGroup = () => {
    return <span className="text-pending">拼团中</span>
};